import React from "react";

interface IconProps {
  handleClick?: () => void;
}

export const UnderlineIcon: React.FC<IconProps> = ({ handleClick }) => {
  return (
    <img
      className="h-[16px] w-[16px] cursor-pointer"
      src="/img/underline-outline.png"
      alt="underline-outline"
      onClick={handleClick}
    />
  );
};
